import PurchaseScreenTypePlan from '@alltrails/amplitude/enums/PurchaseScreenTypePlan';
import type Coupon from '@alltrails/types/Coupon';
import type { Plan } from '@alltrails/types/Plan';
import { isTrial } from './plan';

export default function getPurchaseScreenTypePlan(plan: Plan, coupon?: Coupon): PurchaseScreenTypePlan {
  if (coupon) {
    return 'promo';
  }

  if (isTrial(plan)) {
    return 'free trial';
  }

  return 'non trial';
}
